import React, { useEffect, useState } from 'react'
import { useTranslation } from 'react-i18next';
import { useDispatch, useSelector, shallowEqual } from 'react-redux';
import "flatpickr/dist/themes/material_green.css";
import "react-datetime/css/react-datetime.css";
import { useNavigate } from 'react-router-dom'
import moment from 'moment';
import 'moment/locale/es';
import 'moment/locale/ca';
import Flatpickr from "react-flatpickr";
import Moment from 'react-moment';
import { TipusFixatge } from '../ControlPresencia/TipusFixatge';
import { crearErrorAction, esborrarErrorAction, uiAmagarIncidenciesRestaHoresAction } from '../../actions/ui';
import { addIncidenciaRestaHores } from '../../actions/configIncidenciaAction';

// CANVI: llegeix cp.detallSetmana.fixatges_setmanals en lloc de cp.fixatgeDiaConsultat

export const FormulariIncidenciaRestaHores = ({ diaConsultat }) => {
  const dispatch = useDispatch();
  const navegacio = useNavigate();
  const [t, i18n] = useTranslation('generic');

  const { auth, ui, cp, calendari } = useSelector(
    state => ({ auth: state.auth, ui: state.ui, cp: state.cp, calendari: state.calendari }),
    shallowEqual
  );
  const { loading, msgError } = ui;

  // Llegir fixatges del dia consultat des de detallSetmana
  let fixatgesDia = cp.detallSetmana?.fixatges_setmanals?.find(d => d.dia === diaConsultat)?.fixatges ?? [];
 if (fixatgesDia.length == 0) {
    fixatgesDia= calendari.detallMes.fixatgesMes?.find(d => d.dia === diaConsultat)?.fixatges ?? [];
  }
  const [tipusFixatge, setTipusFixatge]         = useState('');
  const [tipusFixatgeSortida, setTipusFixatgeSortida] = useState('');
  const [dataInici, setDataInici]               = useState(new Date());
  const [dataFinal, setDataFinal]               = useState(new Date());
  const [dataFixatgeSortida, setDataFixatgeSortida] = useState(new Date());
  const [dataFixatgeEntrada, setDataFixatgeEntrada] = useState(new Date());
  const [dataIniciMin, setDataIniciMin]         = useState();
  const [dataFinalMax, setDataFinalMax]         = useState();
  const [dataIniciMinSortida, setDataIniciMinSortida] = useState();
  const [dataFinalMaxSortida, setDataFinalMaxSortida] = useState();

  let idiomaDatetime = t('Generics.idiomaDatetime');
  let listFixatges = [];
  let listFixatgesSortida = [];

  useEffect(() => {
    if (!auth.tokenJwt) navegacio('/');
  }, [auth]);

  // Construir llista de parells entrada+sortida
  if (fixatgesDia.length >= 2) {
    const listItems = fixatgesDia.map(d => ({
      IdFixatge: d.IdFixatge,
      IdTipus_Fixatge: d.IdTipus_Fixatge,
      IdTipusIncidencia_Fixatge: d.IdTipusIncidencia_Fixatge,
      DataHora_Fixatge: d.DataHora_Fixatge
    }));

    for (let index = 0; index < listItems.length - 1; index += 2) {
      const { IdFixatge: id1, IdTipus_Fixatge: t1, IdTipusIncidencia_Fixatge: iti1, DataHora_Fixatge: dh1 } = listItems[index];
      const { IdFixatge: id2, IdTipus_Fixatge: t2, IdTipusIncidencia_Fixatge: iti2, DataHora_Fixatge: dh2 } = listItems[index + 1];
      const pairKey = `${id1}-${id2}`;

      listFixatges.push(
        <div className='form-check mb-1' key={pairKey}>
          <input type="radio" id={`tipusIncidenciaRadio${pairKey}`} className="form-check-input"
            name="tipusIncidencia" value={pairKey}
            onChange={(e) => { setTipusFixatge(e); setDataIniciMin(dh1); setDataFinalMax(dh2); }} />
          <label className="form-check-label" htmlFor={`tipusFixatgeRadio${pairKey}`}>
            <TipusFixatge idTipusFixatge={Number(t1)} idTipusIncidencia={Number(iti1)} /> - <Moment format="HH:mm" date={dh1} />{' '}
            <TipusFixatge idTipusFixatge={Number(t2)} idTipusIncidencia={Number(iti2)} /> - <Moment format="HH:mm" date={dh2} />
          </label>
        </div>
      );

      listFixatgesSortida.push(
        <div className='form-check mb-1' key={id2}>
          <input type="radio" id={`tipusIncidenciaRadio${id2}`} className="form-check-input"
            name="tipusIncidenciaSortida" value={id2}
            onChange={(e) => { setTipusFixatgeSortida(e); setDataIniciMinSortida(dh1); setDataFinalMaxSortida(dh2); setDataFixatgeEntrada(dh1); }} />
          <label className="form-check-label" htmlFor={`tipusFixatgeRadio${id2}`}>
            <TipusFixatge idTipusFixatge={Number(t1)} idTipusIncidencia={Number(iti1)} /> - <Moment format="HH:mm" date={dh1} />{' '}
            <TipusFixatge idTipusFixatge={Number(t2)} idTipusIncidencia={Number(iti2)} /> - <Moment format="HH:mm" date={dh2} />
          </label>
        </div>
      );
    }
  }

  const isFormValid = () => {
    if (tipusFixatge === '') {
      dispatch(crearErrorAction('Cap Selec'));
      return false;
    }
    if (dataInici >= dataFinal) {
      dispatch(crearErrorAction('Data Inici mes gran a Data Final'));
      return false;
    }
    if (moment(dataInici).format('HH:mm:ss') <= moment(dataIniciMin).format('HH:mm:ss') ||
        moment(dataFinal).format('HH:mm:ss') >= moment(dataFinalMax).format('HH:mm:ss')) {
      dispatch(crearErrorAction('Les dates No estan entre el rang definit previament'));
      return false;
    }
    dispatch(esborrarErrorAction());
    return true;
  };

  const handleLogin = (e) => {
    e.preventDefault();
    if (!isFormValid()) return;
    dispatch(addIncidenciaRestaHores(
      tipusFixatge.target._wrapperState.initialValue,
      auth.tokenJwt,
      moment(diaConsultat).format('YYYY-MM-DD ') + moment(dataInici).format('HH:mm:ss'),
      moment(diaConsultat).format('YYYY-MM-DD ') + moment(dataFinal).format('HH:mm:ss')
    ));
    dispatch(uiAmagarIncidenciesRestaHoresAction());
  };

  return (
    <>
      <div className='row'>
        <h5>{t('FormulariIncidencies.crear')}</h5>
        {i18n.language === 'ca'
          ? <p>Si heu de registrar una aturada durant la vostra jornada laboral, com anar a dinar o fer una gestió personal no contemplada en les incidències amb justificant, indiqueu la franja horària en què heu aturat i reprès la vostra jornada. Després de registrar la incidència, es descomptarà el temps del vostre registre.</p>
          : <p>Si tenéis que registrar una parada durante vuestra jornada laboral, como ir a comer o hacer una gestión personal no contemplada en las incidencias con justificante, indicáis la franja horaria en que habéis parado y retomado vuestra jornada. Después de registrar la incidencia, se descontará el tiempo de vuestro registro.</p>
        }
        <div className='mx-4'>{listFixatges}</div>
        {msgError && <div className='alert alert-danger'>{msgError}</div>}
        <div className='container mt-5'>
          {tipusFixatge !== '' && <>
            <p>{t('FormulariIncidencies.txtSelecRestaIncidencia')}</p>
            <div className="row mb-4">
              <div className='col-md-4'>
                <label className="form-label align-right">{t('FormulariIncidencies.txtDataIniciResta')}:</label>
              </div>
              <div className='col-md-8'>
                <Flatpickr
                  options={{ dateFormat: "H:i ", enableTime: true, noCalendar: true, time_24hr: true,
                    locale: idiomaDatetime, minDate: moment(dataIniciMin).format('HH:mm:ss'), maxDate: moment(dataFinalMax).format('HH:mm:ss') }}
                  data-enable-time value={new Date(dataInici)}
                  onChange={(d) => setDataInici(new Date(d))} />
              </div>
            </div>
            <div className="row mb-4">
              <div className='col-md-4'>
                <label className="form-label align-right">{t('FormulariIncidencies.txtDataFinalResta')}:</label>
              </div>
              <div className='col-md-8'>
                <Flatpickr
                  options={{ dateFormat: "H:i ", enableTime: true, noCalendar: true, time_24hr: true,
                    locale: idiomaDatetime, minDate: moment(dataIniciMin).format('H:mm'), maxDate: moment(dataFinalMax).format('H:mm') }}
                  value={new Date(dataFinal)} data-enable-time
                  onChange={(d) => setDataFinal(new Date(d))} />
              </div>
            </div>
          </>}
          <div className="text-center">
            <button onClick={handleLogin} className="btn btn-primary btn-sm m-1" disabled={loading}>
              {t('FormulariIncidencies.btnDadesIncidencia')}
            </button>
          </div>
        </div>
      </div>
    </>
  );
};

export default FormulariIncidenciaRestaHores;